import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectUserScopes} from 'Users/selectors/userProfileSelectors';
import {hasAccessToScopeByApplication} from 'Shared/utilities/applicationId';
import {Scope} from 'Shared/constants/Scope';
import {Application} from 'Users/models/Application';
import {Paper, IconButton, MenuItem} from '@material-ui/core';
import {removeUserType, changeQuotingRole} from 'Users/ducks/userEntry';
import {Close} from '@material-ui/icons';
import OutlinedSelect from 'Shared/components/OutlinedSelect';
import {QuotingUserType} from 'Users/models/User/QuotingUserType';
import {QuotingRole} from 'Users/models/User/Quoting/QuotingRole';

type QuotingUserEntryTypeProps = {
  quotingEntryUserType: QuotingUserType;
  isEdit: boolean;
};

const QuotingUserTypeEntry = (props: QuotingUserEntryTypeProps) => {
  const dispatch = useDispatch();
  const {quotingEntryUserType, isEdit} = props;

  const scopes = useSelector(selectUserScopes);
  const hasUpdateAccess = hasAccessToScopeByApplication(scopes, Scope.UpdateUser, Application.Quoting);
  return (
    <Paper className="agent-user-type-entry">
      <IconButton
        data-testid="quoting-user-remove-btn"
        className="agent-user-type-entry__remove-button"
        onClick={() => dispatch(removeUserType(quotingEntryUserType))}
        disabled={!hasUpdateAccess && props.isEdit}
      >
        <Close />
      </IconButton>
      <p className="agent-user-type-entry__title">Quoting Permissions</p>
      <p className="agent-user-type-entry__description">Select a role to add quoting permissions to this user.</p>
      <OutlinedSelect
        className="agent-user-type-entry__role-select"
        label="Quoting Role"
        value={quotingEntryUserType.value.quotingRole ?? ''}
        onChange={e => dispatch(changeQuotingRole(parseInt(e.target.value, 10) as QuotingRole))}
        disabled={!hasUpdateAccess && isEdit}
      >
        <MenuItem value={QuotingRole.Admin}>Admin</MenuItem>
      </OutlinedSelect>
    </Paper>
  );
};

export default QuotingUserTypeEntry;
